/* Init wow.js */
$(window).on("load", function() {
	var wow = new WOW({
		boxClass: 'wow',
		animateClass: 'animate__animated',
		offset: 200,
		mobile: true,
		live: true
	});
	wow.init();
});

/* Init rellax.js */
$(window).on("load", function() {
	var rellax = new Rellax('.rellax', {
		speed: 2
	});
});

/* Init slick.js */
$(window).on("load", function() {
	if($('.wyndly-slider').length) {
		$('.wyndly-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: true
		});
	}
});

/* Custom Accordion */
$(".toggle").each(function () {
	$(this).find(".content").hide();
  $("h4, .expand, .collapse", this).on("click", function () {
		var toggle_item = $(this).closest('.toggle-item');
		var toggle_heading = $(this);
		var toggle_content = toggle_item.find('.content');
		if (toggle_content.is(":hidden")) {
      toggle_heading.toggleClass("active");
			toggle_content.slideDown(500);
			toggle_item.toggleClass("activate");
    }
    else {
			toggle_heading.removeClass("active");
			toggle_content.slideUp(500);
			toggle_item.removeClass("activate");
		}
  });
});

/* Custom Open Accordion */

$(".toggle-open").each(function () {
	$(this).find(".content").hide();
	$(this).find(".content.first-open").show();
  $("h4, h3, .expand, .collapse", this).on("click", function () {
		$("h4.active").removeClass('active');
		$("h3.active").removeClass('active');
		$(".toggle-item.activate").find(".content").slideUp(500);
		$(".toggle-item.activate").removeClass('activate');
		var toggle_item = $(this).closest('.toggle-item');
		var toggle_heading = $(this);
		var toggle_content = toggle_item.find('.content');
		if (toggle_content.is(":hidden")) {
      toggle_heading.toggleClass("active");
			toggle_content.slideDown(500);
			toggle_item.toggleClass("activate");
    }
    else {
			toggle_heading.removeClass("active");
			toggle_content.slideUp(500);
			toggle_item.removeClass("activate");
		}
  });
});


/* Smooth Scroll On Anchors */
$(function() {
	$('a[href*="#"]:not([href="#"]):not(.noscroll)').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - 125
				}, 1000);
				return false;
			}
		}
	});
});

/* Open External Links in New Tab */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}